<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：添加虚拟评价
    -->
    <el-dialog
    title="添加虚拟评价"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" label-width="100px">
      <div class="common-form">添加虚拟评价</div>
      <el-form-item label="评价内容" prop="content"><el-input v-model="form.content" 
        placeholder="请输入评价内容" type="textarea" class="max-w460"></el-input></el-form-item>

        <el-form-item label="评价等级">
        <el-radio-group v-model="form.score" class="max-w460">
          <el-radio :label="10">好评</el-radio>
          <el-radio :label="20">中评</el-radio>
          <el-radio :label="30">差评</el-radio>
        </el-radio-group>
      </el-form-item>  


     

      <el-form-item size="small" label="" >
        <div class="common-level-rail"><el-button size="small" icon="el-icon-plus" @click="addClick">添加商品</el-button></div>
        <div class="pb50">
          <el-table size="small" :data="tableData" border>
            <el-table-column label="图片" width="60">
              <template slot-scope="scope">
                <div class="product-info">
                  <div class="pic"><img width="30px" height="30px" v-img-url="scope.row.product_image" /></div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="product_name" label="商品"></el-table-column>

            <el-table-column prop="product_name" label="评价数量">
              <template slot-scope="scope">
                <el-input v-model="scope.row.num" type="number" placeholder="请输入数量"  class="max-w460">
                </el-input>
              </template>
            </el-table-column>

            <el-table-column prop="product_name" label="评论图片">
              <template slot-scope="scope">
                <div class="draggable-list">
  
                <div v-for="(item, index) in scope.row.image" :key="item.file_path">
                    <div class="item">
                      <img v-img-url="item.file_path" alt="file_path" style="width: 50px;height: 50px;"/>
                      <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index)"><i class="el-icon-close"></i></a>
                    </div>
                  </div>
                <div class="item img-select" @click="openProductUpload($event,scope.$index)">
                  <i class="el-icon-plus"></i>
                </div>
              </div>
              </template>
              

            </el-table-column>

            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button @click="deleteClick(scope.row)" type="text" size="small" >删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form-item>

     


      <div>评价成功，会自动增加虚拟用户</div>
      <div>一个商品对应一个用户对应一条评论。</div>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
  </div>

   <!--选择商品-->
   <Product :isproduct="isproduct" @closeDialog="closeProductDialogFunc($event)">产品列表弹出层</Product>

   <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
    </Upload>
</el-dialog>
  
</template>

<script>
import PorductApi from '@/api/product.js';
import Upload from "@/components/file/Upload";
import Product from '@/components/product/Product';
export default {
  components: {
    /*商品选择*/
    Product,
    Upload
  },
  data() {
    return {
            /*富文本配置*/
            ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {

        content: '',
        score:10,//评价
      },
      isproduct:false,
      tableData: [],
      product_arr: [],
      loading: false,
      dialogVisible:false,
      isProductUpload:false,
      tableData_index:0,
    };
  },
  created() {
    console.log(11111)
    this.dialogVisible = this.open_add;
  },
  props: ["open_add"],
  methods: {
     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", { openDialog: false,"type":result });
    },
    cancelFunc(){//取消
      this.dialogFormVisible(1)
    },

    onSubmit() {
      let self = this;
      let form = self.form;
     
      console.log(self.tableData);
      form.product = JSON.stringify( self.tableData)
      console.log(form);
      PorductApi.addComment(form,
        true
      )
        .then(data => {
          self.loading = false;
          this.dialogFormVisible(1)
        })
        .catch(error => {});

    },


      /*关闭弹窗*/
      closeProductDialogFunc(e) {
      this.isproduct = e.openDialog;
      if (e.type == 'success') {
        if (this.product_arr.indexOf(e.params.product_id) > -1) {
          this.$message({
            message: '你已选中该产品',
            type: 'error'
          });
          return false;
        }
        let param = {};
        param.product_id = e.params.product_id;
        param.product_name = e.params.product_name;
        param.product_image = e.params.product_image;
        param.sort = 1;
        param.image = [];
        param.num = 1;
        this.tableData.push(param);
        this.product_arr.push(e.params.product_id);
      }
    },
    /*添加商品*/
    addClick() {
      this.isproduct = true;
    },
    /*删除商品*/
    deleteClick(e) {
      let index = this.product_arr.indexOf(e.product_id);
      this.product_arr.splice(index, 1);
      this.tableData.splice(index, 1);
    },




     /*打开上传图片*/
     openProductUpload: function ($event,$index) {

      this.tableData_index = $index;
      this.isProductUpload = true;
    },

    /*上传商品图片*/
    returnProductImgsFunc(e) {
      if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.tableData[this.tableData_index].image.concat(e);
        this.$set(this.tableData[this.tableData_index], "image", imgs);
      }
      this.isProductUpload = false;
    },

    /*删除商品图片*/
    deleteImg(index) {
      this.tableData[this.tableData_index].image.splice(index, 1);
    },

  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/views/product/comment/add.vue